'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { BringtableLogo } from '@/components/branding/BringtableLogo';

export function PublicFooter() {
  const t = useTranslations('landing.footer');

  return (
    <footer className="bg-black pt-20 pb-10">
      <div className="container w-full mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2 pr-8">
            <BringtableLogo className="inline-flex items-center gap-2 text-white" />
            <p className="text-sm text-white/70 mt-6 leading-relaxed max-w-sm">
              {t('description')}
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="mb-6 text-sm font-semibold uppercase tracking-widest text-white">
              {t('product')}
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  href="/#features"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('features')}
                </Link>
              </li>
              <li>
                <Link
                  href="/#four-steps"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('howItWorks')}
                </Link>
              </li>
              <li>
                <Link
                  href="/#pricing"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('pricing')}
                </Link>
              </li>
              <li>
                <Link
                  href="/#case-studies"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('caseStudies')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="mb-6 text-sm font-semibold uppercase tracking-widest text-white">
              {t('resources')}
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  href="/#faq"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('faq')}
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('support')}
                </Link>
              </li>
              <li>
                <a
                  href="mailto:sales@bringtable.com"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('bookSalesDemo')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-6 text-sm font-semibold uppercase tracking-widest text-white">
              {t('legal')}
            </h4>
            <ul className="space-y-4">
              <li>
                <Link
                  href="/privacy"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-sm text-white/50 hover:text-white transition-colors"
                >
                  {t('termsAndConditions')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/10 flex items-center justify-between">
          <p className="text-xs text-white/40">
            {t('copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
}
